var map = {
	"./americanExpress.svg": "852c",
	"./chart.svg": "1446",
	"./discover.svg": "0e6d",
	"./logo.svg": "a8bf",
	"./masterCard.svg": "bf01",
	"./medoro-dark.svg": "3e3e",
	"./medoro-light.svg": "09c6",
	"./paypal.svg": "c24a",
	"./visa.svg": "43f0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7769";